'use strict';

module.exports = function () {
    require('./main.scss');
}


/** WEBPACK FOOTER **
 ** ./src/landing/assets/css/index.js
 **/